import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import { QueryFiltersFormField } from '~/features/advanced-search/query-filters/QueryFiltersFormField';
import { slices } from '~/redux/slices';

import { INITIAL_FILTERS } from '../../constants';

interface Props {
  hideTitle?: boolean;
}

export const GlobalScope = ({ hideTitle = false }: Props) => {
  const intl = useIntl();
  const dispatch = useDispatch();

  const query = useSelector(slices.xRayLibrary.selectors.selectQuery);

  const globalQuery = query.globalQuery;

  return (
    <QueryFiltersFormField
      defaultFilters={INITIAL_FILTERS}
      query={globalQuery}
      title={
        hideTitle
          ? ''
          : intl.formatMessage({
              id: 'GlobalScope.title',
              defaultMessage: 'Global Scope',
              description: 'Title for global scope configuration',
            })
      }
      mode="preview"
      optional={false}
      onQueryChange={(updatedQuery) => {
        dispatch(
          slices.xRayLibrary.actions.setQuery({
            ...query,
            globalQuery: updatedQuery,
          }),
        );
      }}
    />
  );
};
